import { Separator } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { IDebtNoticeStore } from '../../../stores/DebtNoticeStore';
import { ITranslateStore } from '../../../stores/TranslateStore';
import { formatAsCurrency } from '../../../util/FormatUtil';
import BoxNotice from '../../common/BoxNotice';
import UnsettledReceivablesStore from '../../../stores/UnsettledReceivablesStore';
import { formatDate } from '../../../util/DateUtil';

interface IDebtNoticesProps {
  translateStore?: ITranslateStore;
  debtNoticeStore?: IDebtNoticeStore;
  unsettledReceivablesStore?: UnsettledReceivablesStore;
}

@inject('translateStore', 'debtNoticeStore', 'unsettledReceivablesStore')
@observer
export default class DebtNotices extends React.Component<IDebtNoticesProps> {
  public componentDidMount(): void {
    this.props.debtNoticeStore.tryLoadDebtNotice();
  }

  public render(): JSX.Element {
    const debtNotice = this.props.debtNoticeStore.debtNotice;
    const translate = this.props.translateStore.translate;

    if (debtNotice.isFinished) {
      const debtAmount = this.props.unsettledReceivablesStore.unsettledReceivables.payload.debtAmount;
      const noticeText = translate(`invoices.notices.debt-notice.${debtNotice.payload.type}`, {
        totalSum: formatAsCurrency(debtAmount),
        dueDate: formatDate(debtNotice.payload.dueDate),
        bailiffName: debtNotice.payload.bailiff?.name,
        bailiffPhone: debtNotice.payload.bailiff?.phone,
        bailiffEmail: debtNotice.payload.bailiff?.email
      });
      return (
        <React.Fragment>
          <Separator spacing="small" color="invisible" />
          <BoxNotice type="error">{noticeText}</BoxNotice>
        </React.Fragment>
      );
    }
    return null;
  }
}
